// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3o9g8","card":"Cards_card__vdctv","infected":"Cards_infected__1DMMw","recovered":"Cards_recovered__VhzXf","deaths":"Cards_deaths__2ajOn"};